import { render, staticRenderFns } from "./MISadmin.vue?vue&type=template&id=50b85f67"
import script from "./MISadmin.vue?vue&type=script&lang=js"
export * from "./MISadmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports